import { Currency, Locale } from '../apollo/graphqlSchema';
import { ElementOf } from 'ts-essentials';
import { z } from 'zod';

export type numberFormatOptionStyle = 'decimal' | 'currency' | 'percent';

/**
 * NumberFormatOptionProps is a type that defines the options for number formatting
 * decimalPlace and {min, max} is mutually exclusive, details in globalFormat.numberFormat()
 */
export interface INumberFormatOptionProps {
  style: numberFormatOptionStyle;
  /**
   * notation is only applicable when style is 'compact' or 'scientific'
   * compact: 1K, 1M, 1B, 1T
   * scientific: 1e3, 1e6, 1e9, 1e12
   */
  // $ 1e3, $1.23E3  1M% ,1E5%, 10.0000% , 10, 4 decimal place + 'decimal' == 10.0000
  notation?: 'standard' | 'compact' | 'scientific';
  decimalPlace?: number;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
  locale?: Locale;
}

export type ES5NumberFormatOption = Omit<
  INumberFormatOptionProps,
  'decimalPlace' | 'locale'
> & {
  currency?: Currency;
  currencyDisplay?: 'narrowSymbol';
};

/**
 * Kobol doesn't have enum of date formats, therefore we create our own
 * to have strict string type checking
 */
export const DisplayDateFormats = [
  'DD.MM.YYYY',
  'MM/DD/YYYY',
  'YYYY-MM-DD',
  'DD/MM/YYYY',
] as const;

export type DisplayDateFormat = ElementOf<typeof DisplayDateFormats>;

export const dateDisplayFormatSchema = z.enum(DisplayDateFormats);
